import React from 'react';
import styles from './BackButton.scss';
import { formatTestId } from '../../../../utils/test-id/format-testid';

export const BackButton = ({
  label,
  onClick,
  isTabbable = true,
  href: _href = '',
}: {
  label: string;
  onClick: () => void;
  isTabbable?: boolean;
  href?: string;
}) => (
  <div className={styles.wrapper}>
    <button
      aria-label="back to previous menu"
      data-testid={formatTestId(label, 'nav-heading-')}
      onClick={onClick}
      tabIndex={isTabbable ? 0 : -1}
    />
  </div>
);
